import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";

export default class BillingProfile extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "billing-profile";
    static pluralName = "billing-profiles";
    static displayName = "Billing Profile";
    constructor() { super(`${BillingProfile.kind}`, `${BillingProfile.singularName}`, `${BillingProfile.pluralName}`); }
    async getAll(query = {}) { return await this.fetch(qs.stringify({...query}, {encodeValuesOnly: true})); }
    async getById(id, query = {}) { return await this.find(id, {populate: "*", ...query}); }
    async saveMine(data) { return await this.putAction("/billing-profile/me", data); }
}
